import {
  JupiterTheme,
  MockHook,
  JupiterOneGradientIcon,
  CustomLogo,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

import useCurrentOEMBrandingLogoLogic, {
  CurrentOEMBrandingLogoComponentProps,
} from './useCurrentOEMBrandingLogoLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    logo: {
      marginLeft: theme.spacing(2),
    },
    fixedSize: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  });
});

export const CurrentOEMBrandingLogoComponent = ({
  loading,
  currentOEMBrandingLogo,
}: CurrentOEMBrandingLogoComponentProps) => {
  const classes = useStyles();
  if (loading) return null;
  return !currentOEMBrandingLogo ? (
    <CustomLogo>
      <JupiterOneGradientIcon
        className={`${classes.logo} ${classes.fixedSize}`}
      />
    </CustomLogo>
  ) : (
    <img src={currentOEMBrandingLogo} alt="" className={classes.logo} />
  );
};

export default MockHook.withHookHoc(
  CurrentOEMBrandingLogoComponent,
  useCurrentOEMBrandingLogoLogic
);
